import axios from 'axios';
import store from '../store/index';
import {
  Message,
  Loading
} from 'element-ui';

axios.defaults.timeout = 300000; // 请求超时5fen

let loading; //定义loading变量
function startLoading() {
  //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.4)',
  });
}

function endLoading() {
  //使用Element loading-close 方法
  loading.close();
}

let needLoadingRequestCount = 0;
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

// 请求拦截成功
const request_before_ok = config => {
  showFullScreenLoading();
  let loginUesr = localStorage.getItem('loginUesr');
  // let token = '';
  // console.log("----------------------------------------");
  // console.log("本地数据：", loginUesr);

  // config.headers['token'] = token;
  // config.headers['accessToken'] = token;
  // config.headers['app_channel'] = 'PAY_WEB';
  if (loginUesr) {
    loginUesr = JSON.parse(loginUesr);
    // console.log("本地数据111111:token：", loginUesr.token);
    // console.log("----------------------------------------");
    // const appCode = loginUesr.appCode;
    // token = loginUesr.token;
    // config.headers['token'] = token;
    // config.headers['accessToken'] = token;
    // config.headers['appCode'] = appCode || ''
    //针对医药云,添加userId和doctorId
    // config.headers['userId'] = loginUesr.userId || '';
    // config.headers['doctorId'] = loginUesr.doctorLoginInfo ? loginUesr.doctorLoginInfo.doctorId : '';
  }
  return config;
};
// 请求拦截出错
const request_before_fail = err => {
  Message.error({
    message: '请求超时!',
  });
  return Promise.reject(err);
};
// 请求拦截
axios.interceptors.request.use(request_before_ok, request_before_fail);

// 请求成功返回数据
const response_ok = res => {
  tryHideFullScreenLoading();
  switch (res.data.code) {
    case 200:
      return res.data.data;
    case '1':
      return res.data.data;
    case '0':
      Message.error({
        message: res.data.msg,
      });
      return Promise.reject(res.data);
    case 1110001:
      // 显示重新登录弹窗 原401  改为 1110001
      store.state.dialogLoginVisible = true;
      store.state.dialogLoginMsg = res.data.msg;
      return Promise.reject(res);
    case 201:
      Message.error({
        message: res.data.msg,
      });
      return Promise.reject(res);
    case 202:
      Message.error({
        message: '服务器异常，请稍后重试',
      });
      return Promise.reject(res);
    case 500:
      Message.error({
        message: '服务器异常，请稍后重试',
      });
      break;
    default:
      return Promise.reject(res);
  }
};
// 请求失败
const response_fail = err => {
  tryHideFullScreenLoading();
  if (!err.response.status) {
    Message.error({
      message: '服务器异常，请稍后重试',
    });
    return false;
  }
  console.log('响应失败：', err);

  switch (err.response.status) {
    case 500:
      Message.error({
        message: '服务器异常，请稍后重试',
      });
      break;
    case 504:
      Message.error({
        message: '服务器异常，请稍后重试',
      });
      break;
    case 1110001:
      // 显示重新登录弹窗 原401  改为 1110001
      store.state.dialogLoginVisible = true;
      store.state.dialogLoginMsg = err.data.msg;
      return Promise.reject(err);
    case 404:
      Message.error({
        message: '服务器异常，请稍后重试',
      });
      break;
    case 403:
      Message.error({
        message: '权限不足,请联系管理员!',
      });
      break;
    default:
      return Promise.reject(err);
  }
};
// 响应拦截
axios.interceptors.response.use(response_ok, response_fail);

/**
 * POST 请求，JSON格式
 * @param {String} url 接口地址
 * @param {any} params 请求参数
 */
export const postJsonRequest = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

/**
 * POST 请求，formData 格式
 * @param {String} url 接口地址
 * @param {any} params 请求参数
 */
export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    transformRequest: [
      function (data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

/**
 * GET 请求，
 * @param {String} url 接口地址
 * @param {any} params 请求参数
 */
export const getRequest = (url, params = {}) => {
  return axios({
    method: 'get',
    params: params,
    url: url,
  });
};